/**
 * Takes an array of class names and returns a string of class names.
 * @param classes - The class names to join.
 * @returns
 */
export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}
